
export default {
  name: 'SoccerIcon',
  props: {
    classCss: { type: String, default: '' },
  },
}
